import {styled, useTheme} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import {Box} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {CrossOutlined} from '@jobseeker/lotus/icons';
import {PropTypes} from '../type';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
  zIndex: 9999,
  '& .MuiDialog-paper': {
    borderRadius: theme.spacing(2),
  },
}));

const Component = ({
  title,
  titleExtension,
  titleProps,
  disableCrossButton,
  sx,
  subtitle,
  ...props
}: PropTypes) => {
  const handleClose = (event: any) => {
    console.log('🚀 ~ handleClose ~ event:', event, props);
    if (props.onClose) props.onClose(event, 'escapeKeyDown');
  };
  const theme = useTheme();
  const isLarge = useIsLargeDevice();
  return (
    <BootstrapDialog
      fullScreen={!isLarge}
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: props?.maxHeight || 450,
          minWidth: {xxs: 'calc(100vw - 32px)', md: 'fit-content'},
        },
        ...sx,
      }}
      {...props}
    >
      <Box
        sx={{
          overflow: 'hidden',
          position: 'relative',
          ...(props.customBottomMargin && {mb: props.customBottomMargin}),
          ...(props.titleBoxProps &&  props.titleBoxProps),

          pr: 6.5,
          pb: 0.25,
          minHeight: 'fit-content',
        }}
      >
        <DialogTitle
          component={'p'}
          sx={{
            pb: 1,
            pt: 1.5,
            ...titleProps,
          }}
        >
          <Typography
            component={'p'}
            variant="subtitle1"
            color="text.primary"
            display={titleExtension ? 'flex' : 'block'}
            fontWeight={titleExtension ? 600 : 500}
            fontSize={titleExtension ? 14 : 16}
            ml={titleExtension ? -1 : 0}
          >
            {title}
            {titleExtension && (
              <Typography
                fontSize={14}
                fontWeight={600}
                // lineHeight={'23px'}
                sx={{
                  background: theme.palette.pro.main,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                &nbsp;{titleExtension}
              </Typography>
            )}
          </Typography>
          {subtitle ? (
            <Typography
              sx={{
                color: '#7E7E7E',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 400,
              }}
              ml={titleExtension ? -1.25 : 0}
            >
              {subtitle}
            </Typography>
          ) : (
            <></>
          )}
        </DialogTitle>
        {!disableCrossButton && (
          <Box
            sx={{
              position: 'absolute',
              right: 8,
              zIndex: 1,
              top: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'flex-start',
              mt: 1,
            }}
          >
            <IconButton aria-label="close" onClick={handleClose}>
              <Image
                width={18}
                height={18}
                src={CrossOutlined}
                alt={'white cross'}
              />
            </IconButton>
          </Box>
        )}
      </Box>
      <DialogContent sx={{px: 1, pt: 0, pb: 1}}>{props.children}</DialogContent>
    </BootstrapDialog>
  );
};

export default Component;
